export default "__VITE_ASSET__C1tmwJ8W__"